module.exports = __webpack_public_path__ + "static/media/Feature001.172429a3.png";